import React from 'react';
import {
  Autocomplete,
  Box,
  Card,
  Button,
  TextField,
  MenuItem,
  Paper,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography
} from '@mui/material';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { format } from 'date-fns';

import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

import Client from '../Client';
import BackofficeReportsApi from './backofficeReportsApi';
import ProdDateChartGroup from './ProdDateChartGroup';
import SalesExport from './SalesExport';
import AverageSalesPerItemReport from './AverageSalesPerItemReport';

function thousandsSeparator(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function addDays(date, days) {
  if (date) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    result = format(result, 'yyyy-MM-dd');
    return result;
  }
}

let d = new Date();
const getISODay = d => (d.getDay() + 6) % 7 + 1;

let today = format(d, 'yyyy-MM-dd');
let yesterday = format(new Date(new Date(d).setDate(d.getDate() - 1)), 'yyyy-MM-dd');
let d1Month = format(new Date(d.getFullYear(), d.getMonth(), 1), 'yyyy-MM-dd');
let d1Week = format(new Date(new Date(d).setDate(d.getDate() - getISODay(d) + 1)), 'yyyy-MM-dd');

const period = [
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'week', label: 'This Week' },
  { value: 'month', label: 'This Month' },
  { value: 'custom', label: 'Custom' }
];

const objectToCsv = function (data) {
  const csvRows = [];

  if (!data || !data.length) {
    return "No data";
  }

  const headers = Object.keys(data[0]);
  csvRows.push(headers.join(','));

  for (const row of data) {
    const values = headers.map(header => {
      const val = row[header];
      return `"${val}"`;
    });

    csvRows.push(values.join(','));
  }

  return csvRows.join('\n');
};

class ProdLocationChartGroup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      saleslocation_list: { result: [] },
      page: 0,
      rowsPerPage: -1,
      order: 'asc',
      orderBy: null,

      dateFrom: today,
      dateTo: today,

      product: 0,
      delivery: 2,
      salesType: "products",

      productName: { iref: 0, name: "All Products" },
      sx_hidden: { display: 'none' },

      value: "1",

      products: [{ iref: 0, name: "All Products" }],

      deliverys: [
        { iref: 2, name: "All" },
        { iref: 0, name: "Restaurant" },
        { iref: 1, name: "Delivery" },
        { iref: 3, name: "App Clients" }
      ],

      filterData: {}
    };

    this.getData = this.getData.bind(this);
    this.loadSelectableItems = this.loadSelectableItems.bind(this);
    this.doSync = this.doSync.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.addDateFrom = this.addDateFrom.bind(this);
    this.addDateTo = this.addDateTo.bind(this);
    this.selectPeriod = this.selectPeriod.bind(this);
    this.selectProduct = this.selectProduct.bind(this);
    this.selectDelivery = this.selectDelivery.bind(this);
    this.selectSalesType = this.selectSalesType.bind(this);

    this.queryData = {};
  }

  componentDidMount() {
    this.getData();
  }

  loadSelectableItems() {
    const isComboSales = this.state.salesType === "combos";
    const defaultName = isComboSales ? "All Combos" : "All Products";

    const productData = {
      salesType: isComboSales ? "combos" : "products"
    };

    const response = BackofficeReportsApi.getProductsCatalogSummary(
      this.state.client,
      productData
    );

    if (response && Array.isArray(response.products)) {
      this.setState({
        products: response.products.length
          ? response.products
          : [{ iref: 0, name: defaultName }]
      });
    } else {
      console.error("Products/combos list unavailable", {
        payload: productData,
        response: response
      });

      this.setState({
        products: [{ iref: 0, name: defaultName }]
      });
    }
  }

  getData() {
    const queryData = {
      product: this.state.product,
      delivery: this.state.delivery,
      dateFrom: this.state.dateFrom,
      dateTo: this.state.dateTo,
      salesType: this.state.salesType || "products",
      orderBy_name: true
    };

    const data = BackofficeReportsApi.getSalesByProductLocation(this.state.client, queryData);

    if (data) {
      this.setState({ saleslocation_list: data });
    } else {
      this.setState({ saleslocation_list: { result: [] } });
    }

    this.setState({ filterData: queryData });

    this.loadSelectableItems();
  }

  doSync() {
    this.getData();
    this.setState({ page: 0 });
  }

  addDateFrom = (event) => {
    this.setState({
      dateFrom: event.target.value,
      dateTo: event.target.value
    });
  }

  addDateTo = (event) => {
    this.setState({ dateTo: event.target.value });
  }

  selectPeriod = (event) => {
    switch (event.target.value) {
      case "today":
        this.setState(
          {
            sx_hidden: { display: 'none' },
            dateFrom: today,
            dateTo: today
          },
          function () {
            this.doSync();
          }
        );
        break;

      case "yesterday":
        this.setState(
          {
            sx_hidden: { display: 'none' },
            dateFrom: yesterday,
            dateTo: yesterday
          },
          function () {
            this.doSync();
          }
        );
        break;

      case "week":
        this.setState(
          {
            sx_hidden: { display: 'none' },
            dateFrom: d1Week,
            dateTo: today
          },
          function () {
            this.doSync();
          }
        );
        break;

      case "month":
        this.setState(
          {
            sx_hidden: { display: 'none' },
            dateFrom: d1Month,
            dateTo: today
          },
          function () {
            this.doSync();
          }
        );
        break;

      default:
        this.setState(
          { sx_hidden: {} },
          function () {
            this.doSync();
          }
        );
        break;
    }
  }

  selectProduct = (event) => {
    const selectedValue = event.target.value || 0;

    const selectedObj = this.state.products.find(
      (o) => String(o.iref) === String(selectedValue)
    );

    this.setState(
      {
        product: selectedValue,
        productName: selectedObj || {
          iref: 0,
          name: this.state.salesType === "combos" ? "All Combos" : "All Products"
        },
        page: 0
      },
      function () {
        this.doSync();
      }
    );
  }

  selectDelivery = (event) => {
    this.setState(
      {
        delivery: event.target.value,
        page: 0
      },
      function () {
        this.doSync();
      }
    );
  }

  selectSalesType = (event, value) => {
    if (!value) {
      return;
    }

    const defaultName = value === "combos" ? "All Combos" : "All Products";

    this.setState(
      {
        salesType: value,
        product: 0,
        productName: { iref: 0, name: defaultName },
        products: [{ iref: 0, name: defaultName }],
        page: 0
      },
      function () {
        this.doSync();
      }
    );
  }

  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  }

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({
      rowsPerPage: +event.target.value,
      page: 0
    });
  }

  handleRequestSort = (property) => {
    const isAscending = this.state.orderBy === property && this.state.order === 'asc';
    this.setState({ order: isAscending ? 'desc' : 'asc', orderBy: property, page: 0 });
  }

  onDownload = () => {
    const rows = this.state.saleslocation_list?.result || [];
    const selectedName = this.state.productName?.name || (
      this.state.salesType === "combos" ? "All Combos" : "All Products"
    );

    const reportLabel = this.state.salesType === "combos" ? "Combo Sales" : "Product Sales";
    const itemLabel = this.state.salesType === "combos" ? "Combo" : "Product";
    const filePrefix = this.state.salesType === "combos" ? "comboSales" : "productSales";

    const link = document.createElement("a");
    link.download = filePrefix + "_" + selectedName + "_" + this.state.dateFrom + "_" + this.state.dateTo + ".csv";

    const csvData = objectToCsv(rows);
    const csvHeader = reportLabel + "\nDate From: " + this.state.dateFrom + "\nDate To: " + this.state.dateTo + "\n" + itemLabel + ": " + selectedName;
    const csv = "\uFEFF" + csvHeader + "\n" + csvData;

    link.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
    link.click();
  };

  filterSx(widthConfig) {
    return {
      width: widthConfig,
      minWidth: 0,
      '& .MuiInputBase-root': {
        height: 36,
        borderRadius: '12px',
        fontSize: {
          xs: '0.82rem',
          sm: '0.88rem',
        },
        bgcolor: '#fff',
      },
      '& .MuiInputBase-input': {
        fontSize: {
          xs: '16px',
          sm: '0.88rem',
        },
        py: 0.35,
      },
      '& .MuiInputLabel-root': {
        fontSize: {
          xs: '0.76rem',
          sm: '0.82rem',
        },
      },
    };
  }

  renderLocationTab(productSalesList, products, deliverys, selectedOption, isComboSales) {
    const { order, orderBy } = this.state;
    const sortedProductSalesList = orderBy
      ? [...productSalesList].sort((a, b) => {
          const normalize = (value) => {
            const numericValue = Number(String(value ?? '').replace(/,/g, ''));
            return String(value ?? '').trim() !== '' && Number.isFinite(numericValue)
              ? numericValue
              : String(value ?? '').toLocaleLowerCase();
          };
          const aValue = normalize(a[orderBy]);
          const bValue = normalize(b[orderBy]);
          if (aValue < bValue) return order === 'asc' ? -1 : 1;
          if (aValue > bValue) return order === 'asc' ? 1 : -1;
          return 0;
        })
      : productSalesList;

    const tableContainerSx = {
      flex: 1,
      minHeight: 0,
      overflow: 'auto',
      borderTop: '1px solid rgba(15, 23, 42, 0.06)',
      '&::-webkit-scrollbar': {
        height: 8,
        width: 8,
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(15, 23, 42, 0.18)',
        borderRadius: 999,
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: 'rgba(15, 23, 42, 0.04)',
      },
    };

    const tableSx = {
      minWidth: {
        xs: '100%',
        sm: 520,
        md: '100%',
      },
      width: '100%',
      tableLayout: 'fixed',
      '& .MuiTableCell-root': {
        borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
        fontSize: {
          xs: '0.72rem',
          sm: '0.84rem',
          md: '0.92rem',
        },
      },
      '& .MuiTableRow-hover:hover': {
        backgroundColor: 'rgba(26, 35, 126, 0.035)',
      },
    };

    const headerCellSx = {
      py: {
        xs: 0.45,
        sm: 0.85,
      },
      px: {
        xs: 0.35,
        sm: 1,
      },
      bgcolor: '#f8fafc',
      color: '#1a237e',
      fontWeight: 650,
      lineHeight: 1.1,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    };

    const bodyCellSx = {
      py: {
        xs: 0.45,
        sm: 0.8,
      },
      px: {
        xs: 0.35,
        sm: 1,
      },
      whiteSpace: 'nowrap',
      color: '#111827',
      fontWeight: 450,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontVariantNumeric: 'tabular-nums',
    };

    const nameCellSx = {
      ...bodyCellSx,
      position: 'sticky',
      left: 0,
      zIndex: 2,
      bgcolor: '#fff',
      fontWeight: 550,
      fontVariantNumeric: 'normal',
    };

    const nameHeaderCellSx = {
      ...headerCellSx,
      position: 'sticky',
      left: 0,
      zIndex: 4,
    };

    const paginationSx = {
      flexShrink: 0,
      borderTop: '1px solid rgba(15, 23, 42, 0.06)',
      bgcolor: '#fff',
      minHeight: {
        xs: 44,
        sm: 52,
      },
      '& .MuiTablePagination-toolbar': {
        minHeight: {
          xs: 44,
          sm: 52,
        },
        px: {
          xs: 0.5,
          sm: 1,
        },
        flexWrap: {
          xs: 'wrap',
          sm: 'nowrap',
        },
        gap: {
          xs: 0.25,
          sm: 0.5,
        },
      },
      '& .MuiTablePagination-spacer': {
        display: {
          xs: 'none',
          sm: 'block',
        },
      },
      '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
        fontSize: {
          xs: '0.88rem',
          sm: '0.92rem',
          md: '1rem',
        },
        m: 0,
      },
      '& .MuiTablePagination-actions': {
        ml: {
          xs: 0,
          sm: 1,
        },
      },
      '& .MuiTablePagination-actions button': {
        p: {
          xs: 0.25,
          sm: 1,
        },
      },
    };

    return (
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            px: {
              xs: 0.75,
              sm: 1,
            },
            py: {
              xs: 0.65,
              sm: 0.85,
            },
            flexShrink: 0,
            borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
            bgcolor: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: {
                xs: 'stretch',
                sm: 'center',
              },
              justifyContent: 'space-between',
              gap: {
                xs: 0.75,
                sm: 1,
              },
              flexDirection: {
                xs: 'column',
                sm: 'row',
              },
            }}
          >
            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{
                  color: '#1a237e',
                  fontWeight: 800,
                  fontSize: {
                    xs: '0.9rem',
                    sm: '1rem',
                  },
                  lineHeight: 1.2,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                Sales by Location
              </Typography>

              <Typography
                sx={{
                  mt: 0.15,
                  color: '#64748b',
                  fontWeight: 600,
                  fontSize: {
                    xs: '0.72rem',
                    sm: '0.78rem',
                  },
                  lineHeight: 1.2,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                Quantity and value by location for selected {isComboSales ? 'combo' : 'product'}
              </Typography>
            </Box>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: {
                  xs: 'space-between',
                  sm: 'flex-end',
                },
                gap: 0.75,
                flexWrap: 'wrap',
              }}
            >
              <TextField
                id="standard-select-period"
                select
                defaultValue="today"
                size="small"
                sx={this.filterSx({
                  xs: 132,
                  sm: 130,
                })}
                onChange={this.selectPeriod}
              >
                {period.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>

              <Autocomplete
                id="product-select"
                options={products}
                getOptionLabel={(option) => option.name || ""}
                value={selectedOption}
                isOptionEqualToValue={(option, value) => String(option?.iref) === String(value?.iref)}
                onChange={(event, newValue) =>
                  this.selectProduct({ target: { value: newValue?.iref || 0 } })
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder={isComboSales ? "Select combo" : "Select product"}
                    sx={this.filterSx("100%")}
                  />
                )}
                sx={{
                  flex: {
                    xs: '1 1 calc(100% - 180px)',
                    sm: '0 1 180px',
                    md: '0 1 210px',
                    lg: '0 0 220px',
                  },
                  minWidth: {
                    xs: 150,
                    sm: 180,
                  },
                  maxWidth: {
                    xs: '100%',
                    md: 230,
                  },
                  '& .MuiAutocomplete-inputRoot': {
                    height: 36,
                    borderRadius: '12px',
                    bgcolor: '#fff',
                    py: 0,
                  },
                  '& .MuiAutocomplete-input': {
                    fontSize: {
                      xs: '16px',
                      sm: '0.88rem',
                    },
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  },
                  '& .MuiAutocomplete-option': {
                    fontSize: '0.78rem',
                    minHeight: 28,
                    py: 0.25,
                  },
                }}
              />

              <TextField
                id="standard-select-delivery"
                select
                value={this.state.delivery}
                size="small"
                sx={this.filterSx({
                  xs: 108,
                  sm: 112,
                })}
                onChange={this.selectDelivery}
              >
                {deliverys.map((option) => (
                  <MenuItem key={option.iref} value={option.iref}>
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>

              <Box
                sx={{
                  width: {
                    xs: 154,
                    sm: 156,
                  },
                  flexShrink: 0,
                }}
              >
                <ToggleButtonGroup
                  exclusive
                  size="small"
                  value={this.state.salesType}
                  onChange={this.selectSalesType}
                  sx={{
                    width: '100%',
                    height: 36,
                    borderRadius: '12px',
                    overflow: 'hidden',
                    '& .MuiToggleButton-root': {
                      flex: 1,
                      px: {
                        xs: 0.75,
                        sm: 1,
                      },
                      py: 0.35,
                      minHeight: 36,
                      fontSize: {
                        xs: '0.76rem',
                        sm: '0.82rem',
                      },
                      fontWeight: 650,
                      textTransform: 'none',
                      borderColor: 'rgba(26, 35, 126, 0.12)',
                      color: '#1a237e',
                    },
                    '& .Mui-selected': {
                      backgroundColor: 'rgba(26, 35, 126, 0.08)',
                      color: '#1a237e',
                    },
                    '& .Mui-selected:hover': {
                      backgroundColor: 'rgba(26, 35, 126, 0.12)',
                    },
                  }}
                >
                  <ToggleButton value="products">
                    Products
                  </ToggleButton>

                  <ToggleButton value="combos">
                    Combos
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>

              <Tooltip title="Download CSV">
                <Button
                  size="small"
                  onClick={this.onDownload}
                  variant="contained"
                  sx={{
                    minWidth: 36,
                    width: 36,
                    height: 36,
                    p: 0,
                    flexShrink: 0,
                    borderRadius: '12px',
                    color: '#1a237e',
                    bgcolor: 'rgba(26, 35, 126, 0.08)',
                    boxShadow: 'none',
                    border: '1px solid rgba(26, 35, 126, 0.12)',
                    '&:hover': {
                      bgcolor: 'rgba(26, 35, 126, 0.12)',
                      boxShadow: 'none',
                    },
                  }}
                >
                  <FileDownloadIcon fontSize="small" />
                </Button>
              </Tooltip>
            </Box>
          </Box>

          <Box
            sx={{
              ...this.state.sx_hidden,
              mt: 0.85,
              alignItems: 'center',
              gap: 0.75,
              flexWrap: 'wrap',
            }}
          >
            <TextField
              size="small"
              id="date-from"
              label="From"
              type="date"
              value={this.state.dateFrom}
              sx={this.filterSx({
                xs: 'calc(50% - 24px)',
                sm: 130,
              })}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                min: "2020-01-01",
                style: {
                  paddingRight: 5,
                  paddingLeft: 5
                }
              }}
              onChange={this.addDateFrom}
            />

            <TextField
              size="small"
              id="date-to"
              label="To"
              type="date"
              value={this.state.dateTo}
              sx={this.filterSx({
                xs: 'calc(50% - 24px)',
                sm: 130,
              })}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                min: "2020-01-01",
                max: addDays(this.state.dateFrom, 50),
                style: {
                  paddingRight: 5,
                  paddingLeft: 5
                }
              }}
              onChange={this.addDateTo}
            />

            <Tooltip title="Refresh">
              <Button
                onClick={() => this.doSync()}
                variant="contained"
                sx={{
                  minWidth: 36,
                  width: 36,
                  height: 36,
                  p: 0,
                  flexShrink: 0,
                  borderRadius: '12px',
                  boxShadow: 'none',
                  '&:hover': {
                    boxShadow: 'none',
                  },
                }}
              >
                <AutorenewIcon fontSize="small" />
              </Button>
            </Tooltip>
          </Box>
        </Box>

        <TableContainer sx={tableContainerSx}>
          <Table stickyHeader aria-label="product location sales table" size="small" sx={tableSx}>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    ...nameHeaderCellSx,
                    width: {
                      xs: '54%',
                      sm: '56%',
                      md: '56%',
                    },
                  }}
                >
                  <TableSortLabel
                    active={orderBy === 'name'}
                    direction={orderBy === 'name' ? order : 'asc'}
                    onClick={() => this.handleRequestSort('name')}
                  >
                    Location
                  </TableSortLabel>
                </TableCell>

                <TableCell
                  align="right"
                  sx={{
                    ...headerCellSx,
                    width: {
                      xs: '23%',
                      sm: '22%',
                      md: '22%',
                    },
                  }}
                >
                  <TableSortLabel
                    active={orderBy === 'quantity'}
                    direction={orderBy === 'quantity' ? order : 'asc'}
                    onClick={() => this.handleRequestSort('quantity')}
                  >
                    Quantity
                  </TableSortLabel>
                </TableCell>

                <TableCell
                  align="right"
                  sx={{
                    ...headerCellSx,
                    width: {
                      xs: '23%',
                      sm: '22%',
                      md: '22%',
                    },
                  }}
                >
                  <TableSortLabel
                    active={orderBy === 'value'}
                    direction={orderBy === 'value' ? order : 'asc'}
                    onClick={() => this.handleRequestSort('value')}
                  >
                    Value
                  </TableSortLabel>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {(this.state.rowsPerPage > 0
                ? sortedProductSalesList.slice(
                  this.state.page * this.state.rowsPerPage,
                  this.state.page * this.state.rowsPerPage + this.state.rowsPerPage
                )
                : sortedProductSalesList
              ).map((product) => {
                return (
                  <TableRow hover key={product.id} tabIndex={-1}>
                    <TableCell
                      sx={{
                        ...nameCellSx,
                        width: {
                          xs: '54%',
                          sm: '56%',
                          md: '56%',
                        },
                      }}
                    >
                      {product.name}
                    </TableCell>

                    <TableCell align="right" sx={bodyCellSx}>
                      {product.quantity}
                    </TableCell>

                    <TableCell align="right" sx={bodyCellSx}>
                      {product.value}
                    </TableCell>
                  </TableRow>
                );
              })}

              {productSalesList.length === 0 && (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    <Box
                      sx={{
                        py: 4,
                        color: 'text.secondary',
                        fontSize: {
                          xs: '0.86rem',
                          sm: '0.92rem',
                        },
                      }}
                    >
                      No data
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[10, 25, { value: -1, label: 'All' }]}
          labelRowsPerPage="Rows:"
          component="div"
          count={productSalesList.length}
          rowsPerPage={this.state.rowsPerPage}
          page={this.state.page}
          onPageChange={this.handleChangePage}
          onRowsPerPageChange={this.handleChangeRowsPerPage}
          sx={paginationSx}
        />
      </Box>
    );
  }

  render() {
    const isComboSales = this.state.salesType === "combos";
    const allLabel = isComboSales ? "All Combos" : "All Products";

    let products = [{ iref: 0, name: allLabel }];

    if (Array.isArray(this.state.products)) {
      this.state.products.forEach((fData) => {
        if (
          fData &&
          fData.iref !== undefined &&
          String(fData.iref) !== "0"
        ) {
          products.push({
            iref: fData.iref,
            name: fData.name
          });
        }
      });
    }

    let deliverys = [
      { iref: 2, name: "All" },
      { iref: 0, name: "Restaurant" },
      { iref: 1, name: "Delivery" },
      { iref: 3, name: "App Clients" }
    ];

    let productSalesData = [];
    let productSalesList = [];

    if (this.state.saleslocation_list && this.state.saleslocation_list.result) {
      let counter = 0;

      Object.keys(this.state.saleslocation_list.result).forEach(key => {
        let fData = this.state.saleslocation_list.result[key];

        let myData = {
          x: fData.name,
          y: parseInt(fData.value || 0)
        };

        let p = {
          id: counter + 1,
          name: fData.name,
          quantity: thousandsSeparator(fData.quantity || 0),
          value: thousandsSeparator(parseInt(fData.value || 0))
        };

        if (counter < 10) {
          productSalesData.push(myData);
        }

        counter += 1;
        productSalesList.push(p);
      });
    }

    const selectedOption = products.find(
      (p) => String(p.iref) === String(this.state.product)
    ) || products[0];

    return (
      <Paper
        sx={{
          position: 'relative',
          width: '100%',
          height: {
            xs: 600,
            sm: 600,
            md: 620,
            lg: 640,
          },
          maxHeight: {
            xs: 600,
            sm: 600,
            md: 620,
            lg: 640,
          },
          minHeight: 0,
          borderRadius: {
            xs: '14px',
            sm: '16px',
          },
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 4px 14px rgba(15, 23, 42, 0.08)',
          border: '1px solid rgba(15, 23, 42, 0.06)',
          bgcolor: '#fff',
        }}
      >
        <Card
          sx={{
            height: '100%',
            minHeight: 0,
            borderRadius: 0,
            boxShadow: 'none',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          <Tabs
            sx={{
              flexShrink: 0,
              px: {
                xs: 0.75,
                sm: 1,
              },
              minHeight: 44,
              borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
              bgcolor: '#fff',
              '& .MuiTabs-indicator': {
                height: 3,
                borderRadius: '3px 3px 0 0',
                bgcolor: '#1a237e',
              },
              '& .MuiTab-root': {
                minHeight: 44,
                textTransform: 'none',
                fontWeight: 700,
                color: '#64748b',
                fontSize: {
                  xs: '0.82rem',
                  sm: '0.9rem',
                },
                px: {
                  xs: 1,
                  sm: 1.5,
                },
              },
              '& .Mui-selected': {
                color: '#1a237e',
              },
            }}
            value={this.state.value}
            onChange={this.handleChange}
            aria-label="product sales tabs"
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
          >
            <Tab label="Location" value="1" />
            <Tab label="Date" value="2" />
            <Tab label="Sales / item" value="3" />
            <Tab label="Export" value="4" />
          </Tabs>

          {this.state.value === "1" && this.renderLocationTab(
            productSalesList,
            products,
            deliverys,
            selectedOption,
            isComboSales
          )}

          {this.state.value === "2" && (
            <Box
              sx={{
                flex: 1,
                minHeight: 0,
                overflow: "hidden"
              }}
            >
              <ProdDateChartGroup salesType={this.state.salesType} />
            </Box>
          )}

          {this.state.value === "3" && (
            <AverageSalesPerItemReport client={this.state.client} />
          )}

          {this.state.value === "4" && (
            <Box
              sx={{
                flex: 1,
                minHeight: 0,
                overflow: "auto"
              }}
            >
              <SalesExport salesType={this.state.salesType} />
            </Box>
          )}

        </Card>
      </Paper>
    );
  }
}

export default ProdLocationChartGroup;
